export default "__VITE_PUBLIC_ASSET__630bbc94__"